<template>
  <div class="auto-report" v-loading="loading"> <!-- v-loading.fullscreen.lock="globalLoading" element-loading-text="請稍等..." -->
    <div class="controls" v-loading.fullscreen.lock="globalLoading" :element-loading-text="loadingText">
      <div class="button-group">
        <el-button v-for="option in categoryOptions" :key="option.value"
          :type="option.value === selectedCategory ? 'primary' : 'default'" size="mini"
          @click="handleCategoryChange(option.value)">
          {{ option.label }}
        </el-button>
      </div>
      <div class="control-right">
        <el-radio-group
          v-if="!disableLongDateRange && !isTableMode && selectedCategory !== 'RAIN'"
          v-model="renderBatchOption"
          size="mini"
          style="margin-right: 12px;"
          @change="applyBatchFilter"
        >
          <el-radio-button :label="1">分組 1</el-radio-button>
          <el-radio-button :label="2">分組 2</el-radio-button>
          <el-radio-button :label="3">分組 3</el-radio-button>
        </el-radio-group>

        <el-date-picker
          v-model="dateRangeInput"
          type="datetimerange"
          start-placeholder="Start Date"
          end-placeholder="End Date"
          :clearable="false"
          :picker-options="datePickerOptions"
          :default-time="['00:00:00', '23:59:00']"
          format="yyyy/MM/dd HH:mm"
          size="mini"
          style="width: 340px;"
        />
        <el-button type="primary" size="mini" :loading="loading" @click="onExecute" icon="el-icon-caret-right">
          執行
        </el-button>
        <span class="range-label" v-if="rangeLabel">Time Range: {{ rangeLabel }}</span>
        <el-button type="success" size="mini" :loading="exporting" :disabled="exportDisabled"
          icon="el-icon-download" @click="isTableMode ? exportDocxTables() : exportDocx()">
          Export .docx
        </el-button>
      </div>
    </div>

    <el-alert v-if="!isTableMode && !chartGroups.length && !loading" title="No instruments within the target range" type="info"
      show-icon class="empty-state" />

    <!-- TABLE mode -->
    <div v-if="isTableMode" class="table-mode">
      <!-- 自動化測站 - 本周超過管理值告警記錄 -->
      <el-card class="chart-card" style="margin-bottom: 16px;">
        <div class="chart-header">
          <div><div class="chart-title">自動化測站-本周超過管理值告警記錄</div></div>
        </div>
        <el-table :data="tableAlertsAuto" size="mini" v-loading="loadingTables">
          <el-table-column :label="$t('eventList.instrument')" prop="instrument"/>
          <el-table-column :label="$t('eventList.AL')" prop="al_value"/>
          <el-table-column :label="$t('eventList.WSL')" prop="wsl_value"/>
          <el-table-column :label="$t('eventList.startTime')" prop="occurrenceDate"/>
          <!-- 操作 -->
          <el-table-column width="80">
            <template #default="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="removeRow('tableAlertsAuto', scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <!-- 自動化測站 - 本周測站斷訊告警記錄 -->
      <el-card class="chart-card" style="margin-bottom: 16px;">
        <div class="chart-header">
          <div><div class="chart-title">自動化測站-本周測站斷訊告警記錄</div></div>
        </div>
        <el-table :data="tableDownsAuto" size="mini" v-loading="loadingTables">
          <el-table-column type="index" label="編號" width="60"/>
          <el-table-column prop="instrument" label="儀器名稱"/>
          <el-table-column prop="time" label="日期時間" width="160"/>
          <!-- 可編輯的故障原因 -->
          <el-table-column label="故障原因" min-width="220">
            <template #default="scope">
              <el-input
                v-model="scope.row.reason"
                placeholder="請輸入故障原因"
                size="mini"
                clearable
                @keyup.enter.native.stop
              />
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column width="80">
            <template #default="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="removeRow('tableDownsAuto', scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <!-- IoT測站 - 本周超過管理值告警記錄 -->
      <el-card class="chart-card" style="margin-bottom: 16px;">
        <div class="chart-header">
          <div><div class="chart-title">IoT測站-本周超過管理值告警記錄</div></div>
        </div>
        <el-table :data="tableAlertsIot" size="mini" v-loading="loadingTables">
          <el-table-column :label="$t('eventList.instrument')" prop="instrument"/>
          <el-table-column :label="$t('eventList.AL')" prop="al_value"/>
          <el-table-column :label="$t('eventList.WSL')" prop="wsl_value"/>
          <el-table-column :label="$t('eventList.startTime')" prop="occurrenceDate"/>
          <!-- 操作 -->
          <el-table-column width="80">
            <template #default="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="removeRow('tableAlertsIot', scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <!-- IoT測站 - 本周測站斷訊告警記錄 -->
      <el-card class="chart-card">
        <div class="chart-header">
          <div><div class="chart-title">IoT測站-本周測站斷訊告警記錄</div></div>
        </div>
        <el-table :data="tableDownsIot" size="mini" v-loading="loadingTables">
          <el-table-column type="index" label="編號" width="60"/>
          <el-table-column prop="instrument" label="儀器名稱"/>
          <el-table-column prop="time" label="日期時間" width="160"/>
          <!-- 可編輯的故障原因 -->
          <el-table-column label="故障原因" min-width="220">
            <template #default="scope">
              <el-input
                v-model="scope.row.reason"
                placeholder="請輸入故障原因"
                size="mini"
                clearable
                @keyup.enter.native.stop
              />
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column width="80">
            <template #default="scope">
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="mini"
                @click="removeRow('tableDownsIot', scope.$index)"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <div v-else v-for="group in chartGroups" :key="group.id" class="chart-wrapper">
      <el-card class="chart-card">
        <div class="chart-header">
          <div>
            <div class="chart-title">{{ group.title }}</div>
            <div class="chart-subtitle">{{ group.areaName }}</div>
            <div class="chart-meta">
              Series: {{ group.instruments.length }}
              <span v-if="group.rainInstrument">, Rain: {{ group.rainInstrument.name }}</span>
            </div>
          </div>
          <div class="chart-range" v-if="group.rangeLabel">
            {{ group.rangeLabel }}
          </div>
        </div>


        <template v-if="hasChartImage(group)">
          <div class="chart-preview">
            <img :src="chartImages[group.id].image" :alt="`${group.title} preview`" />
          </div>
        </template>
        <Chart
          v-else-if="shouldDisplayChart(group)"
          ref="chartInst"
          ref-in-for
          :key="group.chartKey"
          :useUrl="useUrl"
          :presetInstrumentIds="group.instrumentIds"
          :presetDateRange="dateRange"
          :autoRun="true"
          :autoRain1Day="enableAutoRain1D"
          :autoTable="selectedCategory === 'RAIN'"
          :autoVelocity1Hr="false"
          :interactive="false"
          :fixedRainColor="true"
          :y-axis-fixed-map="yAxisFixedMapFor(group)"
          @ready="payload => handleChartReady(group.id, payload)"
        />
        <div v-else class="chart-placeholder">
          {{ chartStatusText(group) }}
        </div>
        <div class="instrument-tags">
          <span v-for="ins in group.instruments" :key="ins.id" class="instrument-tag">
            {{ ins.name }}
          </span>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Chart from '@/components/chart/index.vue';
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  HeadingLevel,
  AlignmentType,
  ImageRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
} from 'docx';

const MAX_SERIES_PER_CHART = 9;
const MIN_MILEAGE = 28;
const MAX_MILEAGE = 173;
const CATEGORY_OPTIONS = [
  { value: 'TM', label: 'TM' },
  { value: 'ELP', label: 'ELP' },
  { value: 'STI', label: 'STI' },
  { value: 'MC', label: 'MC' },
  { value: 'RAIN', label: 'RAIN' },
];

export default {
  name: 'autoReportComponent',
  components: {
    Chart,
  },
  props: {
    useUrl: {
      type: Boolean,
      default: false,
    },
    visibleCategories: {
      type: Array,
      default: () => ['TM', 'ELP', 'STI', 'MC', 'RAIN', 'TABLE'], // 預設全部顯示
    },
    yAxisFixedMapConfig: {
      type: Object,
      default: () => ({}),
    },
    enableAutoRain1D: {
      type: Boolean,
      default: true,
    },
    disableLongDateRange: {
      type: Boolean,
      default: true,
    },
    // [新增] 外部傳入的日期區間，若有傳入則優先使用
    initialDateRange: {
      type: Array,
      default: () => [],
    },
    // [新增] 儀器名稱過濾陣列，若有傳入，只顯示包含該儀器的圖表
    filterInstrumentNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const end = moment().endOf('day');
    const start = end.clone().subtract(1, 'month').startOf('day');

    // [修改] 決定初始日期：有 props 則用 props，否則用預設一個月
    let initRange = [start.toDate(), end.toDate()];
    if (this.initialDateRange && this.initialDateRange.length === 2) {
      initRange = this.initialDateRange;
    }

    return {
      allChartGroups: [], // 儲存所有的圖表分組 (未切割前)
      renderBatchOption: 1, // 當前選擇的批次 (1, 2, 3)
      loading: false,
      globalLoading: false,
      exporting: false,
      loadingText: '請稍等...',
      currentStep: 0,
      totalStep: 0,
      categoryOptions: CATEGORY_OPTIONS.filter(opt =>
        this.visibleCategories.includes(opt.value),
      ).concat(this.visibleCategories.includes('TABLE') ? [{ value: 'TABLE', label: 'TABLE' }] : []),
      selectedCategory: 'TM',
      typeStationEntries: {
        TM: [],
        ELP: [],
        STI: [],
        MC: [],
      },
      rainByArea: {},
      rainInstruments: [],
      chartGroups: [],
      renderState: {},
      renderBatchSize: 1,
      nextRenderIndex: 0,
      activeRenderingCount: 0,
      chartImages: {},
      dateRange: [moment(initRange[0]).toISOString(), moment(initRange[1]).toISOString()],
      dateRangeInput: initRange,
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
      },
      // TABLE mode state
      loadingTables: false,
      tableAlerts: [],
      tableDowns: [],
      tableAlertsAuto: [],
      tableDownsAuto: [],
      tableAlertsIot: [],
      tableDownsIot: [],
    };
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    timezone() {
      return this.$store.getters['env/timezone'];
    },
    rangeLabel() {
      if (!this.dateRange.length) return '';
      const [start, end] = this.dateRange;
      if (!start || !end) return '';
      const fmt = value => this.$moment(value).tz(this.timezone || 'UTC').format('YYYY/MM/DD HH:mm');
      return `${fmt(start)} ~ ${fmt(end)}`;
    },
    isTableMode() {
      return this.selectedCategory === 'TABLE';
    },
    exportDisabled() {
      if (this.selectedCategory === 'RAIN') return true;
      if (this.isTableMode) return false;
      return !this.chartGroups.length;
    },
    hasAnyTableData() {
      if (!this.isTableMode) return false;
      return (
        (this.tableAlertsAuto && this.tableAlertsAuto.length > 0) ||
        (this.tableDownsAuto && this.tableDownsAuto.length > 0) ||
        (this.tableAlertsIot && this.tableAlertsIot.length > 0) ||
        (this.tableDownsIot && this.tableDownsIot.length > 0)
      );
    },
  },
  watch: {
    // [新增] 監聽 props 變更，同步更新 dateRangeInput
    initialDateRange(newVal) {
      if (Array.isArray(newVal) && newVal.length === 2) {
        this.dateRangeInput = newVal;
      }
    },
    // [新增] 監聽過濾條件變更，重新計算圖表分組
    filterInstrumentNames() {
      this.updateChartGroups(this.selectedCategory);
      // 新增：更新總步數為實際圖表數量
      this.totalStep = this.chartGroups.length;
    },
    selectedCategory(newValue) {
      this.renderBatchOption = 1; // 新增: 切換分類時重置為批次 1

      if (newValue === 'TABLE') {
        const end = this.$moment().endOf('day');
        const start = end.clone().subtract(7, 'days').startOf('day');
        this.dateRangeInput = [start.toDate(), end.toDate()];
        // Clear current table data; wait for onExecute to fetch
        this.tableAlerts = [];
        this.tableDowns = [];
        this.tableAlertsAuto = [];
        this.tableDownsAuto = [];
        this.tableAlertsIot = [];
        this.tableDownsIot = [];
        return;
      }
      
      if (newValue === 'RAIN') {
        const end = this.$moment().endOf('day');
        const start = end.clone().subtract(7, 'days').startOf('day');
        this.dateRangeInput = [start.toDate(), end.toDate()];
        // Clear current table data; wait for onExecute to fetch
        this.tableAlerts = [];
        this.tableDowns = [];
        this.tableAlertsAuto = [];
        this.tableDownsAuto = [];
        this.tableAlertsIot = [];
        this.tableDownsIot = [];
      }
      this.updateChartGroups(newValue);
      this.currentStep = 0;
      // [修改] 原本是計算 this.typeStationEntries[...]，請改為：
      this.totalStep = this.chartGroups.length;
    },
  },
  mounted() {
    if (!this.visibleCategories.includes(this.selectedCategory)) {
      this.selectedCategory = this.visibleCategories[0] || 'TM';
    }
    this.loadAreaStationTree();
  },
  methods: {
    async exportDocxTables() {
      this.exporting = true;
      try {
        const children = [];
        children.push(
          new Paragraph({
            children: [new TextRun({ text: 'Auto Report Tables', bold: true, size: 32 })],
            heading: HeadingLevel.TITLE,
            alignment: AlignmentType.CENTER,
          }),
        );
        if (this.rangeLabel) {
          children.push(
            new Paragraph({ text: `Time Range: ${this.rangeLabel}`, alignment: AlignmentType.CENTER }),
          );
        }

        const addHeading = (text) =>
          children.push(
            new Paragraph({
              children: [
                new TextRun({
                  text,
                  bold: true,
                  font: 'Microsoft JhengHei',
                  size: 24,
                }),
              ],
              spacing: { before: 200, after: 120 },
              alignment: AlignmentType.LEFT,
            }),
          );

        const makeTable = (headers, rows) => {
          const headerRow = new TableRow({
            children: headers.map(
              (h) =>
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: h,
                          bold: true,
                          color: 'FFFFFF',
                          font: 'Microsoft JhengHei',
                          size: 24,
                        }),
                      ],
                      alignment: AlignmentType.CENTER,
                    }),
                  ],
                  shading: {
                    type: 'clear',
                    color: 'auto',
                    fill: '1ABC9C',
                  },
                }),
            ),
          });

          const dataRows = rows.map((cols) =>
            new TableRow({
              children: cols.map(
                (c) =>
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: String(c ?? ''),
                            font: 'Microsoft JhengHei',
                            size: 24, // 12pt
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                  }),
              ),
            }),
          );

          return new Table({
            rows: [headerRow, ...dataRows],
            width: { size: 100, type: WidthType.PERCENTAGE },
          });
        };

        // 當前表為空時，補上一列「本周無告警紀錄」
        const ensureRows = (rows, colCount) => {
          if (Array.isArray(rows) && rows.length > 0) return rows;
          return [[ '本周無告警紀錄', ...Array(Math.max(colCount - 1, 0)).fill('') ]];
        };

        // ---- AUTO - Alerts ----
        addHeading('自動化 - 超過管理值告警紀錄');
        {
          const headers = ['測站名稱', '警戒值', '行動值', '時間'];
          const rows = (Array.isArray(this.tableAlertsAuto) ? this.tableAlertsAuto : []).map((r) => [
            r.instrument || '',
            r.al_value || '',
            r.wsl_value || '',
            r.occurrenceDate || '',
          ]);
          children.push(makeTable(headers, ensureRows(rows, headers.length)));
        }

        // ---- AUTO - Downs ----
        addHeading('自動化 - 斷訊告警紀錄');
        {
          const headers = ['編號', '測站名稱', '時間', '故障原因'];
          const rows = (Array.isArray(this.tableDownsAuto) ? this.tableDownsAuto : []).map((r, idx) => [
            String(idx + 1),
            r.instrument || '',
            r.time || '',
            r.reason || '',
          ]);
          children.push(makeTable(headers, ensureRows(rows, headers.length)));
        }

        // ---- IoT - Alerts ----
        addHeading('IoT - 超過管理值告警紀錄');
        {
          const headers = ['測站名稱', '警戒值', '行動值', '時間'];
          const rows = (Array.isArray(this.tableAlertsIot) ? this.tableAlertsIot : []).map((r) => [
            r.instrument || '',
            r.al_value || '',
            r.wsl_value || '',
            r.occurrenceDate || '',
          ]);
          children.push(makeTable(headers, ensureRows(rows, headers.length)));
        }

        // ---- IoT - Downs ----
        addHeading('IoT - 斷訊告警紀錄');
        {
          const headers = ['編號', '測站名稱', '時間', '故障原因'];
          const rows = (Array.isArray(this.tableDownsIot) ? this.tableDownsIot : []).map((r, idx) => [
            String(idx + 1),
            r.instrument || '',
            r.time || '',
            r.reason || '',
          ]);
          children.push(makeTable(headers, ensureRows(rows, headers.length)));
        }

        const doc = new Document({
          properties: {
            title: 'Auto Report Tables',
            creator: 'AutoReport (Vue)',
            description: 'Tables exported from autoReportComponent.vue',
          },
          sections: [{ children }],
        });

        const blob = await Packer.toBlob(doc);
        const filename = `${this.selectedCategory}_${this.$moment()
          .tz(this.timezone || 'UTC')
          .format('YYYYMMDD_HHmm')}.docx`;

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);

        this.$message?.success?.('已匯出 .docx');
      } catch (err) {
        console.error('Failed to export docx', err);
      } finally {
        this.exporting = false;
      }
    },
    removeRow(listName, index) {
      try {
        const list = this[listName];
        if (!Array.isArray(list)) return;
        if (index < 0 || index >= list.length) return;
        // 直接就地移除即可（Element-UI 的 index 欄會自動重算）
        list.splice(index, 1);
        // 觸發視圖更新
        this.$set(this, listName, list.slice());
      } catch (e) {
        console.error('removeRow failed', listName, index, e);
      }
    },
    getWeekRange() {
      const now = this.$moment();
      const startOfWeek = now.clone().startOf('week');
      const endOfWeek = now.clone().endOf('week');
      return [startOfWeek.toDate(), endOfWeek.toDate()];
    },
    async loadWeeklyTables() {
      try {
        this.loadingTables = true;
        // Use selected range if present; fallback to last 7 days of current week
        const range = Array.isArray(this.dateRangeInput) && this.dateRangeInput.length === 2
          ? this.dateRangeInput
          : this.getWeekRange();
        const [wStart, wEnd] = range;
        const startParam = new Date(wStart);
        const endParam = new Date(wEnd);
        const project = this.selectedProject;
        if (!project || !project._id) return;
        const apiName = `${project._id}/getAlertsList/${startParam}&${endParam}`;
        const res = await this.$axios({ category: 'alerts', method: 'get', apiName });
        const list = Array.isArray(res.data) ? res.data : [];
        // Normalize
        const fmt = v => this.$moment(v).format('YYYY-MM-DD HH:mm');
        const alerts = [];
        const downs = [];
        list.forEach(ele => {
          console.log('Processing alert/down:', ele);
          let instrument = ele.instrument || ele.instrumentId || (ele.instrument_data && ele.instrument_data.data && ele.instrument_data.data[0] && ele.instrument_data.data[0].name) || '';
          const time = fmt(ele.startTime || ele.occurrenceDate || ele.time || new Date());
          const content = (ele.content || ele.msg || '').toString();
          const reason = '';
          if (!instrument && content) {
            instrument = this.parseInstrumentFromContent(content) || '';
          }
          let type = (ele.alert_type || ele.type || '').toString();
          const parsed = this.parseAlertFromContent(content);
          if (parsed.type) type = parsed.type;

          if (type === 'nan_down') {
            downs.push({ instrument, time, reason });
            return;
          }

          if (type === 'AL' || type === 'WSL') {
            let value = parsed.value ?? (ele.data ?? (ele.alert_config_option && ele.alert_config_option.value) ?? '');
            if (typeof value === 'object') value = '';
            alerts.push({
              instrument,
              instrumentId: ele.instrumentId || (ele.instrument_data && ele.instrument_data._id) || '',
              occurrenceDate: time,
              al_value: type === 'AL' ? String(value) : '',
              wsl_value: type === 'WSL' ? String(value) : '',
              content,
            });
          }
        });
        // Sort by time desc
        const toTs = r => this.$moment(r.occurrenceDate || r.time).valueOf();
        this.tableAlerts = alerts.sort((a,b) => toTs(b) - toTs(a));
        // Filter out empty rows and sort
        this.tableDowns = downs
          .filter(r => (r.instrument && String(r.instrument).trim()) || (r.time && String(r.time).trim()))
          .sort((a,b) => toTs(b) - toTs(a));

        // Split into 自動化測站 (TM/ELP) and IoT測站 (STI/MC)
        const isAuto = row => this.getStationCategory(row.instrument, row.content) === 'auto';
        const isIot  = row => this.getStationCategory(row.instrument, row.content) === 'iot';
        this.tableAlertsAuto = this.tableAlerts.filter(isAuto);
        this.tableAlertsIot  = this.tableAlerts.filter(isIot);
        this.tableDownsAuto  = this.tableDowns.filter(r => this.getStationCategory(r.instrument, '') === 'auto');
        this.tableDownsIot   = this.tableDowns.filter(r => this.getStationCategory(r.instrument, '') === 'iot');
      } catch (e) {
        console.error('Failed to load weekly tables', e);
        this.$notifyError?.(e);
      } finally {
        this.loadingTables = false;
      }
    },
    // 從簡訊內容中嘗試解析儀器名稱
    parseInstrumentFromContent(content = '') {
      try {
        if (!content) return '';
        // 儀器故障：抓取「-<儀器>-儀器故障」中的儀器
        let m = content.match(/-([^-\n]+?)-儀器故障/);
        if (m && m[1]) return m[1].trim();
        // 超過(警戒|行動)值：抓取緊鄰告警片段前的儀器名稱，容許中間有 1Hr速率值 等描述
        m = content.match(/-([^-\n]+?)-(?:[^-\n]*-)?(?:超過警戒值|超過行動值)/);
        if (m && m[1]) return m[1].trim();
        return '';
      } catch (_e) {
        return '';
      }
    },
    // 依文字判斷測站類別（TM/ELP → auto ; STI/MC → iot）
    getStationCategoryFromText(text = '') {
      const t = String(text || '').toUpperCase();
      if (!t) return null;
      if (/(^|[^A-Z])TM([^A-Z]|$)/.test(t) || /(ELP)/.test(t)) return 'auto';
      if (/(STI)/.test(t) || /(^|[^A-Z])MC([^A-Z]|$)/.test(t)) return 'iot';
      return null;
    },
    getStationCategory(instrument = '', content = '') {
      return (
        this.getStationCategoryFromText(instrument) ||
        this.getStationCategoryFromText(content)
      );
    },
    openChart(row) {
      const id = row && row.instrumentId;
      if (!id) return;
      try {
        if (this.$router && this.$router.push) {
          this.$router.push({ path: '/chart', query: { id } });
        }
      } catch (e) {
        console.error('openChart failed', e);
      }
    },
    // 解析簡訊內容，擷取告警類型與數值（不含單位）
    parseAlertFromContent(content = '') {
      try {
        if (!content) return { type: null, value: null };
        // 先判斷行動值，再判斷警戒值
        let m = content.match(/超過行動值\s*([+-]?\d+(?:\.\d+)?)/);
        if (m) return { type: 'WSL', value: m[1] };
        m = content.match(/超過警戒值\s*([+-]?\d+(?:\.\d+)?)/);
        if (m) return { type: 'AL', value: m[1] };
        return { type: null, value: null };
      } catch (_e) {
        return { type: null, value: null };
      }
    },
    yAxisFixedMapFor(group) { 
      const external = this.yAxisFixedMapConfig?.[this.selectedCategory];
      if (external) {
        return external;
      }

      if (this.selectedCategory === 'TM') {
        return {
          'mm/日': { min: 0, max: 200, tickInterval: 20 },
          'mm': { min: -50, max: 50, tickInterval: 10 },
        };
      }
      if (this.selectedCategory === 'ELP') {
        const label = String(group?.rangeLabel || group?.stationName || '').toUpperCase();
        
        if (label.includes('TK66')) {
          return {
            'mm/日': { min: 0, max: 200, tickInterval: 40 },
            'GL(m)': { min: -100, max: 0, tickInterval: 20 },
          };
        }

        const target = ['TM', 'ELP'];

        const currentValues = this.categoryOptions.map(opt => opt.value);
        const isMatch = target.length === currentValues.length && 
                        target.every(val => currentValues.includes(val));
        if (isMatch) {
          return {
            'mm/日': { min: 0, max: 80, tickInterval: 16 },
            'GL(m)': { min: -25, max: 0, tickInterval: 5 },
          };
        } else {
          return {
            'mm/日': { min: 0, max: 200, tickInterval: 40 },
            'GL(m)': { min: -25, max: 0, tickInterval: 5 },
          };
        }
      }
      if (this.selectedCategory === 'MC') {
        return {
          '%': { min: 0, max: 60, tickInterval: 15 },
          'mm/日': { min: 0, max: 200, tickInterval: 50 },
        };
      }
      if (this.selectedCategory === 'STI') {
        return {
          '度': { min: -1, max: 1, tickInterval: 0.5 },
          'mm/日': { min: 0, max: 200, tickInterval: 50 },
        };
      }
      return { 'mm/日': { min: 0 } };
    },
    async loadAreaStationTree() {
      const project = this.selectedProject;
      if (!project || !project._id) return;
      this.loading = true;
      try {
        const res = await this.$axios({
          category: 'project',
          method: 'get',
          apiName: `${project._id}/area-station-instrument`,
        });
        const areas = res.data?.area || [];
        const typeStationEntries = {
          TM: [],
          ELP: [],
          STI: [],
          MC: [],
        };
        const rainByArea = {};
        const globalRain = [];

        areas.forEach(area => {
          const rawAreaName = typeof area.name === 'string' ? area.name.trim() : '';
          if (rawAreaName && rawAreaName.includes('維護資訊')) return;
          const areaName = rawAreaName || 'Unknown Area';
          const areaId = area._id || area.id || areaName;
          const areaMileage = this.parseMileage(areaName);

          (area.station || []).forEach(station => {
            const stationId = station._id || station.id || `${areaId}-${station.name}`;
            const stationName = station.name || 'Unknown Station';
            const stationMileage = this.parseMileage(stationName);
            const stationMileageValue = Number.isFinite(stationMileage.value)
              ? stationMileage.value
              : areaMileage.value;
            const stationMileageTag = stationMileage.tag || areaMileage.tag || stationName;

            const stationByType = {
              TM: [],
              ELP: [],
              STI: [],
              MC: [],
            };
            const stationRain = [];

            (station.instrument || []).forEach(instrument => {
              const entry = this.buildInstrumentEntry(instrument, {
                areaId,
                areaName,
                stationId,
                stationName,
                stationMileageValue,
                stationMileageTag,
              });
              if (!entry) return;
              if (entry.type === 'RAIN') {
                stationRain.push(entry);
                rainByArea[areaId] = rainByArea[areaId] || [];
                rainByArea[areaId].push(entry);
                globalRain.push(entry);
                return;
              }
              if (stationByType[entry.type]) {
                stationByType[entry.type].push(entry);
              }
            });

            Object.keys(stationByType).forEach(type => {
              if (!stationByType[type].length) return;
              typeStationEntries[type].push({
                areaId,
                areaName,
                stationId,
                stationName,
                stationMileageValue,
                stationMileageTag,
                instruments: stationByType[type].slice().sort((a, b) => (a.mileageValue ?? Infinity) - (b.mileageValue ?? Infinity)),
                rainInstruments: stationRain.slice(),
              });
            });
          });
        });

        Object.keys(typeStationEntries).forEach(type => {
          typeStationEntries[type].sort((a, b) => (a.stationMileageValue ?? Infinity) - (b.stationMileageValue ?? Infinity));
        });
        globalRain.sort((a, b) => (a.mileageValue ?? Infinity) - (b.mileageValue ?? Infinity));

        Object.keys(rainByArea).forEach(areaId => {
          rainByArea[areaId] = this.dedupeById(rainByArea[areaId]);
        });
        const uniqueRain = this.dedupeById(globalRain);

        this.typeStationEntries = typeStationEntries;
        this.rainByArea = rainByArea;
        this.rainInstruments = uniqueRain;

        const hasEntries = type => (this.typeStationEntries[type] || []).length > 0;
        let targetType = this.selectedCategory;
        if (!hasEntries(targetType)) {
          const fallback = this.categoryOptions.find(opt => hasEntries(opt.value));
          targetType = fallback ? fallback.value : targetType;
        }
        if (this.selectedCategory !== targetType) {
          this.selectedCategory = targetType;
        } else {
          this.updateChartGroups(targetType);
        }
      } catch (error) {
        console.error('Failed to load area-station instruments:', error);
        if (this.$notifyError) this.$notifyError(error);
      } finally {
        this.loading = false;
      }
    },
    buildInstrumentEntry(instrument, context) {
      if (!instrument || !instrument._id) return null;
      const rawName = instrument.latestVersion?.name || instrument.name || instrument.instrument_name || instrument._id;
      const instrumentMileage = this.parseMileage(rawName);
      let mileageValue = Number.isFinite(instrumentMileage.value)
        ? instrumentMileage.value
        : context.stationMileageValue;
      const mileageTag = instrumentMileage.tag || context.stationMileageTag;
      if (!Number.isFinite(mileageValue)) return null;

      const type = this.detectType(instrument, context.stationName);
      if (!type) return null;
      if (type !== 'RAIN' && !this.isMileageInRange(mileageValue)) return null;
      if (type === 'STI' && !this.isValidStiDirection(rawName)) return null;

      return {
        id: instrument._id,
        name: rawName,
        type,
        mileageValue,
        mileageTag,
        areaId: context.areaId,
        areaName: context.areaName,
        stationId: context.stationId,
        stationName: context.stationName,
      };
    },
    detectType(instrument, stationName = '') {
      const sources = [
        instrument?.instrument_type?.name,
        instrument?.instrument_type?.code,
        instrument?.name,
        instrument?.latestVersion?.name,
        stationName,
      ].map(text => (text || '').toUpperCase());
      if (this.includesAny(sources, ['RAIN', 'RG'])) return 'RAIN';
      if (this.includesAny(sources, ['TM'])) return 'TM';
      if (this.includesAny(sources, ['ELP'])) return 'ELP';
      if (this.includesAny(sources, ['MC'])) return 'MC';
      if (this.includesAny(sources, ['STI'])) return 'STI';
      return null;
    },
    includesAny(values, keywords) {
      return values.some(value => value && keywords.some(keyword => value.includes(keyword)));
    },
    parseMileage(source = '') {
      const match = /TK\s*(\d+)(?:\s*\+\s*(\d+))?/i.exec(source);
      if (!match) return { value: Number.POSITIVE_INFINITY, tag: '', km: null, meter: null };
      const km = parseInt(match[1], 10);
      const meter = match[2] ? parseInt(match[2], 10) : 0;
      const value = km + meter / 1000;
      const tag = `TK${km}${meter ? `+${meter}` : ''}`;
      return { value, tag, km, meter };
    },
    isMileageInRange(value) {
      return Number.isFinite(value) && value >= MIN_MILEAGE && value <= MAX_MILEAGE;
    },
    isValidStiDirection(name = '') {
      return /(?:^|[-_])(EW|X)(?:\b|$)/i.test(name);
    },
    handleCategoryChange(value) {
      if (this.selectedCategory === value) return;
      this.selectedCategory = value;
      if (this.selectedCategory === 'ELP') this.enableAutoRain1D = true;
      if (this.selectedCategory === 'TM' && this.yAxisFixedMapConfig?.[this.selectedCategory]) this.enableAutoRain1D = false;
    },
    applyBatchFilter() {
      if (this.disableLongDateRange || this.selectedCategory === 'RAIN' || this.isTableMode) {
        // 如果禁止長區間，或是在 RAIN / TABLE 模式下，就不分批次
        this.chartGroups = this.allChartGroups || [];
      } else {
        const total = (this.allChartGroups || []).length;
        if (total === 0) {
          this.chartGroups = [];
        } else {
          // 將圖表分為 3 等份
          const chunkSize = Math.ceil(total / 3);
          const start = (this.renderBatchOption - 1) * chunkSize;
          const end = start + chunkSize;
          this.chartGroups = this.allChartGroups.slice(start, end);
        }
      }
      
      this.totalStep = this.chartGroups.length;
      this.chartImages = {};
      this.setupRenderQueue();
    },
    updateChartGroups(type = this.selectedCategory) {
      // Special handling for RAIN: one chart for all rain instruments
      if (type === 'RAIN') {
        const allRain = Array.isArray(this.rainInstruments) ? this.rainInstruments.slice() : [];
        const instrumentIds = allRain.map(i => i.id);
        
        // 修改: 存入 allChartGroups
        this.allChartGroups = instrumentIds.length
          ? [{
            id: 'RAIN-ALL-0',
            title: 'RAIN - All Instruments',
            areaName: '',
            stationName: 'RAIN',
            instruments: allRain,
            rainInstrument: null,
            instrumentIds,
            rangeLabel: '',
            chartKey: `RAIN-ALL-0-${instrumentIds.join('-')}`,
          }]
          : [];
        
        // 新增: 呼叫過濾器
        this.applyBatchFilter();
        return;
      }
      const stationEntries = this.typeStationEntries?.[type] || [];
      const typeLabel = (this.categoryOptions.find(opt => opt.value === type)?.label) || type;
      const groups = [];
      stationEntries.forEach(stationEntry => {
        const chunks = this.chunkInstruments(stationEntry.instruments, MAX_SERIES_PER_CHART);
        chunks.forEach((chunk, index) => {
          if (!chunk.length) return;
          const rainInstrument = this.findRainInstrument(stationEntry, chunk);
          const instrumentIds = chunk.map(item => item.id);
          if (rainInstrument && !instrumentIds.includes(rainInstrument.id)) {
            instrumentIds.push(rainInstrument.id);
          }
          const rangeLabel = this.describeRange(chunk);
          const group = {
            id: `${type}-${stationEntry.stationId}-${index}`,
            title: `${stationEntry.stationName}-Chart ${index + 1}`,
            areaName: stationEntry.areaName,
            stationName: stationEntry.stationName,
            instruments: chunk,
            rainInstrument,
            instrumentIds,
            rangeLabel,
            chartKey: `${type}-${stationEntry.stationId}-${index}-${instrumentIds.join('-')}`,
          };

          // [新增] 一般圖表的過濾邏輯
          if (this.filterInstrumentNames && this.filterInstrumentNames.length > 0) {
            const hasMatch = chunk.some(ins => this.filterInstrumentNames.includes(ins.name));
            if (!hasMatch) return;
          }
          
          groups.push(group);
        });
      });
      // 修改: 存入 allChartGroups 並呼叫過濾器取代原本的賦值
      this.allChartGroups = groups;
      this.applyBatchFilter();
    },
    chunkInstruments(list, size = MAX_SERIES_PER_CHART) {
      if (!Array.isArray(list) || list.length === 0) return [];
      const chunks = [];
      for (let idx = 0; idx < list.length; idx += size) {
        chunks.push(list.slice(idx, idx + size));
      }
      return chunks;
    },
    dedupeById(list = []) {
      const seen = new Set();
      return (list || []).filter(item => {
        if (!item || !item.id || seen.has(item.id)) return false;
        seen.add(item.id);
        return true;
      });
    },
    findRainInstrument(stationEntry, instruments) {
      const candidates = [];
      const seen = new Set();
      const append = list => {
        (list || []).forEach(item => {
          if (!item || !item.id || seen.has(item.id)) return;
          seen.add(item.id);
          candidates.push(item);
        });
      };
      append(stationEntry.rainInstruments);
      append(this.rainByArea[stationEntry.areaId]);
      append(this.rainInstruments);
      if (!candidates.length) return null;
      const target = this.computeAverageMileage(instruments, stationEntry);
      let best = null;
      let bestDist = Number.POSITIVE_INFINITY;
      candidates.forEach(item => {
        if (!Number.isFinite(item.mileageValue)) return;
        const dist = Math.abs(item.mileageValue - target);
        if (dist < bestDist) {
          best = item;
          bestDist = dist;
        }
      });
      return best || candidates[0];
    },
    computeAverageMileage(instruments, stationEntry) {
      const valid = instruments.filter(item => Number.isFinite(item.mileageValue));
      if (valid.length) {
        const sum = valid.reduce((acc, item) => acc + item.mileageValue, 0);
        return sum / valid.length;
      }
      if (Number.isFinite(stationEntry.stationMileageValue)) return stationEntry.stationMileageValue;
      return MIN_MILEAGE;
    },
    describeRange(items) {
      if (!items.length) return '';
      const withMileage = items.filter(item => item.mileageTag);
      if (!withMileage.length) return '';
      if (withMileage.length === 1) return withMileage[0].mileageTag;
      const first = withMileage[0].mileageTag;
      const last = withMileage[withMileage.length - 1].mileageTag;
      if (first === last) return first;
      return `${first} ~ ${last}`;
    },
    setupRenderQueue() {
      this.renderState = {};
      this.nextRenderIndex = 0;
      this.activeRenderingCount = 0;
      (this.chartGroups || []).forEach((group, index) => {
        if (!group || !group.id) return;
        this.$set(this.renderState, group.id, {
          active: false,
          rendered: false,
          index,
        });
      });
    },
    onExecute() {
      try {
        const [start, end] = this.dateRangeInput || [];

        if (!start || !end) {
          this.$message?.warning?.('請先選擇時間區間');
          return;
        }

        // 以「純日期」計算差異，避免時區偏移 / 時間差造成一天誤差
        const startDate = new Date(start);
        const endDate = new Date(end);

        // 計算毫秒差
        const diffMs = endDate - startDate;
        // 換算成「天」
        const diffDays = diffMs / (1000 * 60 * 60 * 24);

        if (diffDays > 33 && this.disableLongDateRange) {
          this.$message?.warning?.('時間區間不能超過 33 天');
          return;
        }
        
        this.currentStep = 0;
        // [修改] 原本是計算 this.typeStationEntries[...]，請改為：
        this.totalStep = this.chartGroups.length;
        
        this.loadingText = `進度 ${this.currentStep}/${this.totalStep}...`;

        // Normalize to ISO string (keep same behavior as previous logic)
        this.dateRange = [new Date(start).toISOString(), new Date(end).toISOString()];
        this.globalLoading = true;

        if (this.isTableMode) {
          this.loadWeeklyTables().finally(() => {
            this.globalLoading = false; // ← TABLE 模式結束時關閉
          });
          return;
        }
        // Reset previous results and start rendering (charts only)
        this.chartImages = {};
        this.setupRenderQueue();
        this.primeRenderQueue();
      } catch (e) {
        console.error('Execute failed:', e);
        this.globalLoading = false;
      }
    },
    hasChartImage(group) {
      // Under RAIN, never switch to static preview image
      if (this.selectedCategory === 'RAIN') return false;
      return this.hasChartImageById(group?.id);
    },
    hasChartImageById(groupId) {
      const entry = this.chartImages[groupId];
      return Boolean(entry && entry.status === 'ready' && entry.image);
    },
    shouldDisplayChart(group) {
      if (this.hasChartImage(group)) return false;
      const state = this.renderState[group.id];
      return Boolean(state && (state.active || state.rendered));
    },
    chartStatusText(group) {
      const imageStatus = this.chartImages[group.id];
      if (imageStatus) {
        if (imageStatus.status === 'loading') return 'Generating chart image...';
        if (imageStatus.status === 'error') return 'Failed to capture chart';
      }
      const state = this.renderState[group.id];
      if (!state) return 'Chart is queued...';
      if (state.active) return 'Rendering chart...';
      if (state.rendered) return 'Chart ready';
      return 'Chart is queued...';
    },
    primeRenderQueue() {
      if (!Array.isArray(this.chartGroups)) return;
      const limit = Math.max(1, Math.floor(Number(this.renderBatchSize) || 0));
      while (this.activeRenderingCount < limit && this.nextRenderIndex < this.chartGroups.length) {
        const group = this.chartGroups[this.nextRenderIndex];
        if (!group) break;
        const state = this.renderState[group.id] || {};
        if (state.rendered || state.active) {
          this.nextRenderIndex += 1;
          continue;
        }
        const activated = this.activateGroup(group);
        this.nextRenderIndex += 1;
        if (activated) {
          this.activeRenderingCount += 1;
        }
      }
    },
    activateGroup(group) {
      if (!group) return false;
      const prev = this.renderState[group.id] || {};
      if (prev.active) return false;
      this.$set(this.renderState, group.id, {
        ...prev,
        active: true,
        rendered: prev.rendered || false,
      });
      return true;
    },
    markGroupRendered(groupId) {
      const state = this.renderState[groupId] || {};
      if (state.rendered) {
        if (state.active && this.activeRenderingCount > 0) {
          this.activeRenderingCount -= 1;
          this.$set(this.renderState, groupId, { ...state, active: false });
          this.primeRenderQueue();
        }
        return;
      }
      this.$set(this.renderState, groupId, {
        ...state,
        active: false,
        rendered: true,
      });
      if (this.activeRenderingCount > 0) {
        this.activeRenderingCount -= 1;
      }
      this.primeRenderQueue();

      const allDone = Object.values(this.renderState).every(s => s.rendered);
      if (allDone) {
        this.globalLoading = false;
      }
    },
    async handleChartReady(groupId, payload) {
      const { getBase64, chartInstance, yMin, yMax } = payload || {};
      console.log(`Group ${groupId}: yMin=${yMin}, yMax=${yMax}`);

      if (!chartInstance || !chartInstance.yAxis || chartInstance.yAxis.length === 0) {
        console.warn(`⚠️ Chart instance missing for ${groupId}`);
        return;
      }

      const config = this.yAxisFixedMapConfig?.[this.selectedCategory];
      const axis_TM = chartInstance.yAxis[0];
      const axis_RAIN = chartInstance.yAxis[1];

      if (config) {
        const key_TM = Object.keys(config)[1];
        const { min: fixedMin, max: fixedMax, tickInterval } = config[key_TM] || {};

        let newMin = fixedMin;
        let newMax = fixedMax;
        let needUpdate = false;

        if (yMin < fixedMin) {
          newMin = Math.floor(yMin / 10) * 10;
          needUpdate = true;
        }
        if (yMax > fixedMax) {
          newMax = Math.ceil(yMax / 10) * 10;
          needUpdate = true;
        }

        if (needUpdate) {
          axis_TM.update(
            {
              min: newMin,
              max: newMax,
              tickInterval: tickInterval || 10,
            },
            false,
          );

          if (this.disableLongDateRange){
            axis_RAIN.update(
              {
                min: 0,
                max: (newMax - newMin) * 0.3,
                tickInterval: 3,
              },
              false,
            );
          } else {
            axis_RAIN.update(
              {
                min: 0,
                max: (newMax - newMin) * 3,
                tickInterval: 30,
              },
              false,
            );
          }

          chartInstance.redraw();
          console.log(`Updated ${groupId} y-axis from [${fixedMin}, ${fixedMax}] to [${newMin}, ${newMax}]`);
        }
      }

      // 延遲等待 redraw 後再截圖
      await new Promise(r => setTimeout(r, 3000));

      if (this.selectedCategory === 'RAIN') {
        this.markGroupRendered(groupId);
        this.currentStep += 1;
        this.loadingText = `進度 ${this.currentStep}/${this.totalStep}...`;
        return;
      }

      if (this.hasChartImageById(groupId)) {
        this.markGroupRendered(groupId);
        this.currentStep += 1;
        this.loadingText = `進度 ${this.currentStep}/${this.totalStep}...`;
        return;
      }

      this.captureChartImage(groupId, getBase64);
      this.currentStep += 1;
      this.loadingText = `進度 ${this.currentStep}/${this.totalStep}...`;
    },
    async captureChartImage(groupId, getBase64) {
      const entry = this.chartImages[groupId];
      if (entry && entry.status === 'loading') return;
      const getBase64Fn = getBase64 && typeof getBase64 === 'function' ? getBase64 : null;
      if (!getBase64Fn) {
        this.markGroupRendered(groupId);
        return;
      }
      this.$set(this.chartImages, groupId, { status: 'loading', image: null });
      try {
        const snapshot = await getBase64Fn();
        const normalized = this.normalizeSnapshotPayload(snapshot);
        const dataUrl = normalized.image || normalized.preview;
        if (!dataUrl) throw new Error('Empty chart image payload');
        this.$set(this.chartImages, groupId, { status: 'ready', image: dataUrl });
      } catch (error) {
        console.error('Failed to capture chart image', groupId, error);
        this.$set(this.chartImages, groupId, { status: 'error', image: null });
      } finally {
        this.markGroupRendered(groupId);
      }
    },
    normalizeSnapshotPayload(payload) {
      if (!payload) {
        return { image: '', preview: '', svg: '', width: null, height: null };
      }
      if (typeof payload === 'string') {
        return { image: payload, preview: payload, svg: '', width: null, height: null };
      }
      const image = typeof payload.image === 'string' ? payload.image : '';
      const svg = typeof payload.svg === 'string' ? payload.svg : '';
      const width = Number.isFinite(payload.width) ? payload.width : null;
      const height = Number.isFinite(payload.height) ? payload.height : null;
      const preview = svg ? this.svgToDataUrl(svg) : image;
      return {
        image,
        preview: preview || image,
        svg,
        width,
        height,
      };
    },
    svgToDataUrl(svg) {
      if (!svg) return '';
      if (typeof window === 'undefined' || typeof window.btoa !== 'function') return '';
      try {
        return `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(svg)))}`;
      } catch (error) {
        console.error('Failed to convert SVG to data URL', error);
        return '';
      }
    },
    async exportDocx() {
      if (!Array.isArray(this.chartGroups) || this.chartGroups.length === 0) {
        this.$message?.warning?.('沒有可匯出的圖表');
        return;
      }

      this.exporting = true;
      try {
        // 蒐集要匯出的項目（有圖片才收）
        const items = this.chartGroups
          .map((group) => {
            const entry = this.chartImages[group.id];
            const img = entry && entry.status === 'ready' ? entry.image : null;
            return img
              ? {
                title: group.title || '',
                subtitle: group.areaName || '',
                meta:
                  (group.rangeLabel ? `Range: ${group.rangeLabel}` : '') ||
                  (this.rangeLabel ? `Range: ${this.rangeLabel}` : ''),
                instruments:
                  (group.instruments || [])
                    .map((ins) => ins?.name)
                    .filter(Boolean)
                    .join('、') || '',
                imgDataUrl: img,
              }
              : null;
          })
          .filter(Boolean);

        if (!items.length) {
          this.$message?.warning?.('無圖表可匯出');
          return;
        }

        // 讀取每張圖片尺寸，並轉成位元組
        const prepared = await Promise.all(
          items.map(async (it) => {
            const { withBorder, width, height, bytes } = await this.addBorderAndGetBytes(it.imgDataUrl, 4, '#000');

            // 以 A4 版面安全寬度做縮放（docx 預設頁邊約 2.54cm）
            const MAX_W = 600; // px（大約 6.25in @96dpi），可依需求調整
            const scale = width > MAX_W ? MAX_W / width : 1;
            const w = Math.round(width * scale);
            const h = Math.round(height * scale);

            return { ...it, imgDataUrl: withBorder, bytes, w, h };
          }),
        );

        // 組文件段落
        const children = [];

        // 文件封面（可選）
        children.push(
          new Paragraph({
            children: [
              new TextRun({
                text: 'Auto Report Charts',
                bold: true,
                size: 32,
              }),
            ],
            heading: HeadingLevel.TITLE,
            alignment: AlignmentType.CENTER,
            spacing: { before: 2000, after: 400 },
          }),
        );

        if (this.rangeLabel) {
          children.push(
            new Paragraph({
              text: `Time Range: ${this.rangeLabel}`,
              alignment: AlignmentType.CENTER,
            }),
          );
        }
        
        children.push(new Paragraph({ pageBreakBefore: true }));

        // === 每頁三個圖表：僅套用於 TM/ELP/STI/MC ===
        const threePerPageCategories = new Set(['TM', 'ELP', 'STI', 'MC']);
        if (threePerPageCategories.has(this.selectedCategory)) {
          const PER_PAGE = 3;
          prepared.forEach((it, idx) => {
            // 每滿 3 張前插入分頁（下一段前分頁）
            if (idx > 0 && idx % PER_PAGE === 0) {
              children.push(new Paragraph({ pageBreakBefore: true }));
            }

            // 標題
            if (it.title) {
              const parts = it.title.split('-');
              const merged = parts.length >= 2 ? `${parts[0]}-${parts[1]} ${it.subtitle}` : `${it.title} ${it.subtitle}`;
              children.push(new Paragraph({ children: [new TextRun({ text: merged, bold: true })], spacing: { after: 80 } }));
            }

            // 圖片
            children.push(
              new Paragraph({
                children: [new ImageRun({ data: it.bytes, transformation: { width: it.w, height: it.h } })],
                alignment: AlignmentType.CENTER,
              }),
            );

            // 圖與圖之間留白（同頁）
            const isEndOfPage = (idx + 1) % PER_PAGE === 0 || idx === prepared.length - 1;
            if (!isEndOfPage) children.push(new Paragraph({ spacing: { after: 200 } }));
          });
        } else {
          // 其他分類維持原單張逐段輸出
          prepared.forEach((it) => {
            if (it.title) {
              children.push(
                new Paragraph({
                  children: [new TextRun({ text: it.title.split('-')[0] + '-' + it.title.split('-')[1] + ' ' + it.subtitle, bold: true })],
                  spacing: { after: 120 },
                }),
              );
            }
            children.push(
              new Paragraph({
                children: [new ImageRun({ data: it.bytes, transformation: { width: it.w, height: it.h } })],
                alignment: AlignmentType.CENTER,
              }),
            );
          });
        }

        const doc = new Document({
          properties: {
            title: 'Auto Report Charts',
            creator: 'AutoReport (Vue)',
            description: 'Charts exported from autoReportComponent.vue',
          },
          sections: [{ children }],
        });

        const blob = await Packer.toBlob(doc);
        const filename = `${this.selectedCategory}_${this.$moment()
          .tz(this.timezone || 'UTC')
          .format('YYYYMMDD_HHmm')}.docx`;

        // 下載（無須 file-saver）
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);

        this.$message?.success?.('已匯出 .docx');
      } catch (err) {
        console.error('Failed to export docx', err);
      } finally {
        this.exporting = false;
      }
    },
    dataURLToUint8Array(dataURL) {
      const parts = dataURL.split(',');
      if (parts.length < 2) throw new Error('Invalid image dataURL');
      const b64 = parts[1];
      const binary = atob(b64);
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
      return bytes;
    },
    getImageSize(dataURL) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
        img.onerror = (e) => reject(new Error('讀取圖像尺寸失敗'));
        img.src = dataURL;
      });
    },
    addBlackBorderToDataURL(dataURL, border = 4, color = '#000') {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // 新尺寸 = 原圖 + 兩側邊框
            const W = img.naturalWidth + border * 2;
            const H = img.naturalHeight + border * 2;

            canvas.width = W;
            canvas.height = H;

            // 先塗滿黑框
            ctx.fillStyle = color;
            ctx.fillRect(0, 0, W, H);

            // 再把原圖畫在中間(邊框內縮)
            ctx.drawImage(img, border, border);

            // 輸出 PNG dataURL
            const out = canvas.toDataURL('image/png');
            resolve(out);
          } catch (e) {
            reject(e);
          }
        };
        img.onerror = () => reject(new Error('讀取圖像失敗'));
        img.src = dataURL;
      });
    },
    async addBorderAndGetBytes(dataURL, border = 4, color = '#000') {
      const withBorder = await this.addBlackBorderToDataURL(dataURL, border, color);
      const { width, height } = await this.getImageSize(withBorder);
      const bytes = this.dataURLToUint8Array(withBorder);
      return { withBorder, width, height, bytes };
    },
  },
};
</script>

<style scoped>
.auto-report {
  max-width: 1500px;
}

.controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.button-group {
  display: flex;
  gap: 8px;
}

.control-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.range-label {
  font-size: 13px;
  color: #666;
}

.chart-wrapper {
  margin-bottom: 16px;
}

.chart-placeholder {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  background: #fafafa;
  font-size: 14px;
  margin-top: 8px;
}
.chart-preview {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 8px;
  background: #fff;
}
.chart-preview img {
  display: block;
  width: 100%;
}

.chart-card {
  width: 100%;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 12px;
}

.chart-title {
  font-weight: 600;
  font-size: 16px;
}

.chart-subtitle {
  font-size: 13px;
  color: #909399;
  margin-top: 2px;
}

.chart-meta {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.chart-range {
  font-size: 13px;
  color: #909399;
}

.instrument-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.instrument-tag {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 12px;
  color: #606266;
}

.empty-state {
  margin-bottom: 16px;
}
</style>


